import { defineComponent as _defineComponent } from 'vue';
import { renderTrustedMarkdown } from '~/functions/markdown';
import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds';
import { TemplateEngineContext } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    impactGoal: null,
    impact: null,
    impactSolution: null
  },
  setup: function setup(__props) {
    var showIntroductionImpactProfile = ref(false);
    return {
      __sfc: true,
      showIntroductionImpactProfile: showIntroductionImpactProfile,
      renderTrustedMarkdown: renderTrustedMarkdown,
      IMPACT_SECTION_IDS: IMPACT_SECTION_IDS,
      TemplateEngineContext: TemplateEngineContext
    };
  }
});